import React, { FC } from 'react';

import { Box } from '@mui/material';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { FilterItem } from '../FilterItem';
import useStyles from './styles';

interface HierarchicalMenuListProps {
  isPrimary?: boolean;
  items: any[];
  refine: (value: string) => void;
}

const HierarchicalMenuList: FC<HierarchicalMenuListProps> = ({
  items,
  refine,
  isPrimary = false,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <Box>
        {items && items.length > 0 ? (
          items.map((item) => (
            <div className={cn(classes.listItem, !!item.data && classes.expanded)} key={item.label}>
              <FilterItem
                withArrow={isPrimary}
                label={item.label}
                count={item.count}
                refine={refine}
                isRefined={item.isRefined}
                filterValue={item.label}
                value={item.value}
              />
              {item.data && (
                <div className={classes.sublist}>
                  <HierarchicalMenuList items={item.data} refine={refine} />
                </div>
              )}
            </div>
          ))
        ) : (
          <div className={classes.noItems}>{t('page.discover.noFiltersAvailable')}</div>
        )}
      </Box>
    </div>
  );
};

export default HierarchicalMenuList;
